var AbstractResourceController = require("../common/AbstractResourceController");
var AppsListView = require("./AppsListView");
var Utils = require("common/Utils");

/**
 * @class
 * @extends {AbstractResourceController}
 * @constructor
 */
function AppsController() {
    AbstractResourceController.call(this);

    const self = this;
    const supportedSubTypes = {};

    const super_checkForPrerequisites = this.checkForPrerequisites;
    this.checkForPrerequisites = function(id) {
        // If resource is already active then do not prompt for prerequisites
        const resourceItem = CudaLaunch.models.resources.getResource(id);
        if (!self.isAllowedToLaunch(resourceItem)) {
            return;
        }

        if (resourceItem.type !== "vpn_app"
            || !CudaLaunch.controllers.VPNConnectionController
            || !CudaLaunch.controllers.VPNConnectionController.isActiveResourceAndShowConnections(resourceItem)) {
            return super_checkForPrerequisites(id);
        }
    };

    /**
     *
     * @type {AppsListView}
     */
    var listView = new AppsListView(this.checkForPrerequisites);
    this.setResourcesView(listView);

    var launchers = {};
    var views = [listView];

    /**
     * @override
     * @inheritDoc
     */
    this.getViews = function() {
        return views;
    };

    /**
     * @override
     * @inheritDoc
     */
    this.getResourceTypes = function() {
        return Object.keys(launchers);
    };

    self.subscribeToChannel("Electron", "show-apps-view", function() {
        self.showView(listView);
    });

    var super_filterResources = this.filterResources;
    this.filterResources = function(resources) {
        var filtered = Utils.objectFilter(resources, function(res) {
            var subTypes = supportedSubTypes[res.type];
            return !subTypes || subTypes.contains(res.forwarded_service) || subTypes.contains(res.app_type);
        });

        return super_filterResources.call(this, filtered);
    };

    /**
     * @abstract
     * @param {ResourcesModel~ResourceItem} resource the resource to launch
     * @param {string} launchToken token
     */
    this.launchResource = function(resource, launchToken) {
        // Delegate off to the appropriate launcher that has been registered with us
        var launcher = launchers[resource.type];

        if (launcher) {
            launcher.launchResource(resource, self, launchToken);
        } else {
            console.error("Unable to launch resource '" + resource.name + "' - no launcher available");
        }
    };

    this.addResourceType = function(key, launcher, renderer, subTypes) {
        listView.addRenderer(key, renderer);
        views = views.concat(launcher.getViews());
        launchers[key] = launcher;

        if (subTypes) {
            supportedSubTypes[key] = subTypes;
        }
    };

    /**
     * @override
     * @inheritsDoc
     */
    this.getId = function() {
        return "AppsController";
    };
}

AppsController.prototype = new AbstractResourceController();
AppsController.prototype.constructor = AppsController;

module.exports = AppsController;


//////////////////
// WEBPACK FOOTER
// ./apps/AppsController.js
// module id = 77
// module chunks = 0